// class AccordionAnimation {
//   constructor(el) {
//     // Store the <details> element
//     this.el = el;
//     // Store the <summary> element
//     this.summary = el.querySelector('summary');
//     // Store the <div class="content"> element
//     this.content = el.querySelector('.accordion__content');

//     // Store the animation object (so we can cancel it if needed)
//     this.animation = null;
//     // Store if the element is closing
//     this.isClosing = false;
//     // Store if the element is expanding
//     this.isExpanding = false;
//     // Detect user clicks on the summary element
//     this.summary.addEventListener('click', (e) => this.onClick(e));
//   }

//   onClick(e) {
//     // Stop default behaviour from the browser
//     e.preventDefault();
//     // Add an overflow on the <details> to avoid content overflowing
//     this.el.style.overflow = 'hidden';
//     // Check if the element is being closed or is already closed
//     if (this.isClosing || !this.el.open) {
//       this.open();
//     // Check if the element is being openned or is already open
//     } else if (this.isExpanding || this.el.open) {
//       this.shrink();
//     }
//   }

//   shrink() {
//     // Set the element as "being closed"
//     this.isClosing = true;
    
//     // Store the current height of the element
//     const startHeight = `${this.el.offsetHeight}px`;
//     // Calculate the height of the summary
//     const endHeight = `${this.summary.offsetHeight}px`;
    
//     // If there is already an animation running
//     if (this.animation) {
//       // Cancel the current animation
//       this.animation.cancel();
//     }
    
//     // Start a WAAPI animation
//     this.animation = this.el.animate({
//       // Set the keyframes from the startHeight to endHeight
//       height: [startHeight, endHeight]
//     }, {
//       duration: 300,
//       easing: 'ease-out'
//     });
    
//     // When the animation is complete, call onAnimationFinish()
//     this.animation.onfinish = () => this.onAnimationFinish(false);
//     // If the animation is cancelled, isClosing variable is set to false
//     this.animation.oncancel = () => this.isClosing = false;
//   }

//   open() {
//     // Apply a fixed height on the element
//     this.el.style.height = `${this.el.offsetHeight}px`;
//     // Force the [open] attribute on the details element
//     this.el.open = true;
//     // Wait for the next frame to call the expand function
//    this.closeOthers();
//   }

//   expand() {
//     // Set the element as "being expanding"
//     this.isExpanding = true;
//     // Get the current fixed height of the element
//     const startHeight = `${this.el.offsetHeight}px`;
//     // Calculate the open height of the element (summary height + content height)
//     const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    
//     // If there is already an animation running
//     if (this.animation) {
//       // Cancel the current animation
//       this.animation.cancel();
//     }
    
//     // Start a WAAPI animation
//     this.animation = this.el.animate({
//       // Set the keyframes from the startHeight to endHeight
//       height: [startHeight, endHeight]
//     }, {
//       duration: 600,
//       easing: 'ease-out'
//     });
//     // When the animation is complete, call onAnimationFinish()
//     this.animation.onfinish = () => this.onAnimationFinish(true);
//     // If the animation is cancelled, isExpanding variable is set to false
//     this.animation.oncancel = () => this.isExpanding = false;
//   }

//   onAnimationFinish(open) {
//     // Set the open attribute based on the parameter
//     this.el.open = open;
//     // Clear the stored animation
//     this.animation = null;
//     // Reset isClosing & isExpanding
//     this.isClosing = false;
//     this.isExpanding = false;
//     // Remove the overflow hidden and the fixed height
//     this.el.style.height = this.el.style.overflow = '';
//   }
// }

// customElements.define(
//   'details-disclosure',
//   class DetailsDisclosure extends HTMLElement {
//     constructor() {
//       super();

//       const features = {
//           allow_multiple : "data-allow-multiple",
//           allow_focus   : "data-allow-focus",
//       }

//       this.details = this.querySelectorAll('details');
//       this.mainDetails = null;
//       this.content = null;

//       if (!this.hasAttribute(features.allow_multiple)) {
//         this.details.forEach((targetDetail) => {
//           targetDetail.addEventListener(
//             'click',
//             (event) => {
//               this.mainDetails = targetDetail;
//               this.content = this.mainDetails.querySelector('summary').nextElementSibling;
//               this.onClick()
//             }
//           );
//         });
//       }

//       if (this.hasAttribute(features.allow_multiple)) {
//         this.details.forEach((targetDetail) => {
//           targetDetail.addEventListener(
//             'toggle',
//             this.onToggle.bind(this),
//           );
//         });
//       }

//       if (this.hasAttribute(features.allow_focus)) {
//         this.details.forEach((targetDetail) => {
//           targetDetail.addEventListener(
//             'focusout',
//             this.onFocusOut.bind(this),
//           );
//         });
//       }


//       // this.details.forEach((targetDetail) => {
//       //   new AccordionAnimation(targetDetail);
//       // });
//     }

//     onFocusOut() {
//       setTimeout(() => {
//         if (!this.contains(document.activeElement)) this.close();
//       });
//     }

//     onToggle(detail) {
//       if (!this.animations) this.animations = this.content.getAnimations();

//       if (detail.currentTarget.hasAttribute('open')) {
//         this.animations.forEach((animation) => animation.play());
//       } else {
//         this.animations.forEach((animation) => animation.cancel());
//       }
//     }

//     onClick() {
//       if (!this.animations) this.animations = this.content.getAnimations();
//       this.details.forEach((detail) => {
//         if (detail !== this.mainDetails) {
//           // detail.removeAttribute("open");
//         }
//       });      
//     }

//     close() {
//       this.details.forEach((detail) => {
//         detail.removeAttribute('open');
//         detail.querySelector('summary')
//           .setAttribute('aria-expanded', false);
//       }); 

//     }
//   },
// );

class Details {
  constructor(el, settings) {
    this.group    = el;
    this.details  = this.group.getElementsByClassName("details");
    this.toggles  = this.group.getElementsByClassName("details__summary");
    this.contents = this.group.getElementsByClassName("details__content");    
    
    // Set default settings if necessary
    this.settings = Object.assign({
      speed: 300,
      one_visible: false
    }, settings);
    
    // Setup inital positions
    for (let i = 0; i < this.details.length; i++) {
      const detail  = this.details[i];
      const toggle  = this.toggles[i];
      const content = this.contents[i];
      
      // Set transition-duration to match JS setting
      detail.style.transitionDuration = this.settings.speed + "ms";
      
      // Set initial height to transition from
      if (!detail.hasAttribute("open")) {
        detail.style.height = toggle.clientHeight + "px";
      } else {
        detail.style.height = toggle.clientHeight + content.clientHeight + "px";
      }
    }
    
    // Setup click handler
    this.group.addEventListener("click", (e) => {      
      if (e.target.classList.contains("details__summary")) {
        e.preventDefault();
        
        let num = 0;
        for (let i = 0; i < this.toggles.length; i++) {
          if (this.toggles[i] === e.target) {
            num = i;
            break;
          }
        }
        
        if (!e.target.parentNode.hasAttribute("open")) {
          this.open(num);
        } else {
          this.close(num);
        }
      }
    });
  }
  
  open(i) {
    const detail = this.details[i];
    const toggle = this.toggles[i];
    const content = this.contents[i];
    
    // If applicable, hide all the other details first
    if (this.settings.one_visible) {
      for (let a = 0; a < this.toggles.length; a++) {
        if (i !== a) this.close(a);
      }
    }
    
    // Update class
    detail.classList.remove("is-closing");
    
    // Get height of toggle
    const toggle_height = toggle.clientHeight;
    
    // Momentarily show the contents just to get the height
    detail.setAttribute("open", true);
    const content_height = content.clientHeight;
    detail.removeAttribute("open");
    
    // Set the correct height and let CSS transition it
    detail.style.height = toggle_height + content_height + "px";
    
    // Finally set the open attr
    detail.setAttribute("open", true);
    detail.classList.add("open");
  }
  
  close(i) {
    const detail = this.details[i];
    const toggle = this.toggles[i];
    
    // Update class
    detail.classList.add("is-closing");
    
    // Get height of toggle
    const toggle_height = toggle.clientHeight;
    
    // Set the height so only the toggle is visible
    detail.style.height = toggle_height + "px";
    
    setTimeout(() => {
      // Check if still closing
      if (detail.classList.contains("is-closing"))
        detail.removeAttribute("open");
        detail.classList.remove("is-closing");
        detail.classList.remove("open");
    }, this.settings.speed);
  }
}

(() => {
  const els = document.getElementsByClassName("details-group");
  
  for (let i = 0; i < els.length; i++) {
    const details = new Details(els[i], {
      speed: 500,
      one_visible: true
    });
  }
})();